import React, { useEffect, useState } from "react";
import { Button, Divider, Form, Input, message, Modal, Select } from "antd";
import { find, get, pick } from "lodash";
import _ from "lodash";
import { useSelector } from "react-redux";
import service from "services";
import { removeVietnameseTones } from "lib/admin";

const TripodModal = ({ config, onShowModal }) => {
  const { visible, isCreate, dataSource } = config;
  const [form] = Form.useForm();
  const [isFetching, setIsFetching] = useState(false);

  const title = isCreate ? "Tạo mới tripod" : "Chỉnh sửa tripod";

  const listStation = useSelector(x => x.app.listStationsV2Select);

  const onSubmit = async values => {
    setIsFetching(true);
    let data = {
      ...values,
      type: 1,
      connect_type: 1,
      station_id: get(values, "station_id.value")
    };

    if (isCreate === false) {
      data.id = dataSource.id;
      data = {
        ...data
      };
    }
    if (isCreate) {
      service.TripodService.createTripod(data)
        .then(res => {
          const isSuccess = get(res, "data.success");
          if (isSuccess) {
            message.success("Tạo mới tripod thành công");
            onShowModal(false);
          } else {
            let error = get(res, "data.message");
            message.error("Có lỗi khi tạo mới tripod");
            message.error(error);
          }
        })
        .catch(e => {
          message.error("Có lỗi khi tạo mới tripod");
        })
        .finally(() => setIsFetching(false));
    } else {
      service.TripodService.updateTripod(data, data.id)
        .then(res => {
          const isSuccess = get(res, "data.success");
          if (isSuccess) {
            message.success("Sửa tripod thành công");
            onShowModal(false);
          } else {
            message.error("Có lỗi khi sửa tripod");
          }
        })
        .catch(e => {
          message.error("Có lỗi khi sửa tripod");
        })
        .finally(() => setIsFetching(false));
    }
  };

  const footer = (
    <div className="d-flex justify-content-end align-items-center">
      <Button loading={isFetching} type="primary" onClick={form.submit}>
        Lưu
      </Button>
    </div>
  );

  useEffect(
    () => {
      if (isCreate === false && visible) {
        form.setFieldsValue({
          checkin_type: dataSource.checkin_type,
          device_model: dataSource.device_model,
          name: dataSource.name,
          device_id: dataSource.device_id,
          firmware_version: dataSource.firmware_version,
          public_ip: dataSource.public_ip,
          public_port_tcp: dataSource.public_port_tcp,
          station_id: find(listStation, x => x.value == dataSource.station_id)
        });
      } else {
        form.setFieldsValue({
          checkin_type: undefined,
          device_model: undefined,
          dvr_name: "",
          name: "",
          device_id: "",
          firmware_version: "",
          public_ip: "",
          public_port_tcp: "",
          station_id: undefined
        });
      }
    },
    [isCreate, visible, form, dataSource, listStation]
  );

  return (
    <Modal
      open={visible}
      title={title}
      footer={footer}
      width={600}
      onCancel={() => onShowModal(false)}
    >
      <Form
        labelCol={{ span: 8 }}
        labelAlign="left"
        form={form}
        onFinish={onSubmit}
      >
        <Form.Item
          required
          label="Kho"
          labelAlign="left"
          name="station_id"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn kho"
            }
          ]}
        >
          <Select
            filterOption={(inputValue, option) =>
              _.includes(
                _.toLower(removeVietnameseTones(option.label)),
                _.toLower(removeVietnameseTones(inputValue))
              )
            }
            placeholder="Chọn kho"
            allowClear
            
            labelInValue
            showSearch
            options={listStation}
          />
        </Form.Item>
        <Form.Item
          required
          label="Tên thiết bị"
          labelAlign="left"
          name="name"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên thiết bị"
            }
          ]}
        >
          <Input autoFocus placeholder="Nhập tên thiết bị" />
        </Form.Item>
        <Form.Item
          required
          label="SN"
          labelAlign="left"
          name="device_id"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập SN"
            }
          ]}
        >
          <Input autoFocus placeholder="Nhập SN" />
        </Form.Item>
        <Form.Item
          label="Firmware Version"
          labelAlign="left"
          name="firmware_version"
        >
          <Input autoFocus placeholder="Nhập firmware version" />
        </Form.Item>
        <Form.Item
          required
          label="Device Model"
          labelAlign="left"
          name="device_model"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn model"
            }
          ]}
        >
          <Select allowClear  placeholder="Chọn device model">
            <Select.Option value={"SF400/ID"}>SF400/ID</Select.Option>
            <Select.Option value={"F18"}>F18</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          required
          label="Loại checkin"
          labelAlign="left"
          name="checkin_type"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn loại checkin"
            }
          ]}
        >
          <Select allowClear  placeholder="Chọn loại checkin">
            <Select.Option value={"checkin"}>Checkin</Select.Option>
            <Select.Option value={"checkout"}>Checkout</Select.Option>
          </Select>
        </Form.Item>
        <Divider className="text-primary" orientation="left">
          Public
        </Divider>
        <Form.Item dependencies={["local_ip"]} noStyle={true}>
          {({ getFieldValue }) => {
            let isRequired = !getFieldValue("local_ip");
            return (
              <Form.Item
                label="IP/Domain"
                labelAlign="left"
                name="public_ip"
                required={isRequired}
                rules={[
                  {
                    required: isRequired,
                    message: "Vui lòng nhập địa chỉ ip hoặc tên miền"
                  }
                ]}
              >
                <Input placeholder="Nhập địa chỉ ip hoặc domain" />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item dependencies={["local_tcp_port"]} noStyle={true}>
          {({ getFieldValue }) => {
            let isRequired = !getFieldValue("local_tcp_port");
            return (
              <Form.Item
                label="Port TCP"
                labelAlign="left"
                labelCol={{ span: 8 }}
                name="public_port_tcp"
                required={isRequired}
                rules={[
                  {
                    required: isRequired,
                    message: "Vui lòng nhập cổng"
                  }
                ]}
              >
                <Input placeholder="Port TCP" />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TripodModal;
